/*
 * @Author: wufan 
 * @Date: 2019-09-30 11:04:26 
 * @Last Modified by: wufan
 * @Last Modified time: 2019-10-09 18:00:32
 * 产品动态-列表
 */

import React, { useState, useEffect } from 'react';
import './ProductDynamicListPage.less';
import {
  withRouter,Route
} from 'react-router-dom';
import Header from '../home/Header';
import Axios from '../../core/axios';
import moment from 'moment';
import { Pagination } from 'antd';
import ProductDynamicDetailPage from './ProductDynamicDetailPage';
import XMTD from '../../core/xmTD';

const ProductDynamicListPage = (props: any) => {
  const [productList, setProductList] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    Axios.postJSON("manage/anon/productDynamic/queryProductDynamicList", {
      "current": pageNum,
      "size": 10,
      "typeEnum": "PRODUCT_DYNAMIC"
    })
      .then((res: any) => {
        setProductList(res.result.records);
        setTotalCount(res.result.total);
      })
  }, [pageNum])

  function onChangePageNum(pageNum: number) {
    setPageNum(pageNum);
  }

  function LinkToDetailPage(productDynamicId:string){ 
    props.history.push({
      pathname: `/product_dynamic/${productDynamicId}`,
    })
  }

  // 打点
  function XMDataDotDynamic(item:any) { 
    let url = props.history.location;
    let params = url.search.slice(1).split("&");
    let paramList:any = {}
    params.forEach((item: any) => {
      const key: string = (item.split("=")[0]);
      paramList[key] = decodeURIComponent(item.split("=")[1]);
   })
    paramList.name = "B端-点击-产品动态列表标题";
    paramList.dynamicId = item.id;
    paramList.title = item.title;
    XMTD(paramList);
  }

  let { match } = props;
  return (
    <div className="product-dynamic-page">
      <div className='top'>
        <Header />
      </div>
      <div className='content-box'>
        <div className="position-title">
          您所在的位置：产品动态
        </div>
        <div className="list-box">
          <ul>
            {
              productList.map((item:any, index:number) => {
                return <li key={item.id} onClick={() => {
                  LinkToDetailPage(item.id);
                  XMDataDotDynamic(item);
                }}
                  style={{cursor:"pointer"}}
                >
                <span className="title">
                  {item.title}
                </span>
                <span className="time">
                  {moment(item.displayTime).format("YYYY-MM-DD")}
                </span>
                </li>
              })
            }
          </ul>
        </div>
        <div className="page-control">
              <Pagination showQuickJumper defaultCurrent={1} total={Number(totalCount)} onChange={onChangePageNum} defaultPageSize={10} current={pageNum} />
            </div>
      </div>
      <Route
          path={`${match.url}/:id`}
          component={ProductDynamicDetailPage}
        />
    </div>
  )

}

export default withRouter(ProductDynamicListPage);
